// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1bVW5","container":"styles_container__1x-MQ","title":"styles_title__3PQa7","wrapper":"styles_wrapper__152IT","answer":"styles_answer__oq1op"};